export { default } from './MenuItem';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/MenuItem/index.js
// module id = 302
// module chunks = 121